import { render, staticRenderFns } from "./DetailsCardLuggages.vue?vue&type=template&id=f0a04bb6&scoped=true&"
import script from "./DetailsCardLuggages.vue?vue&type=script&lang=js&"
export * from "./DetailsCardLuggages.vue?vue&type=script&lang=js&"
import style0 from "./DetailsCardLuggages.vue?vue&type=style&index=0&id=f0a04bb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0a04bb6",
  null
  
)

/* custom blocks */
import block0 from "./DetailsCardLuggages.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBadge,VIcon,VSpacer,VTooltip})
